/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController, IonContent } from '@ionic/angular';
import { football_fields } from 'src/assets/newFootballFields';
import { DimensionsService } from '../services/dimensions.service';
import { Router } from '@angular/router';
import { Coordinates, MapService, MapView } from '../services/map.service';
import { FiltersComponent } from '../filters/filters.component';
import {
  FilterItem,
  FiltersService,
  PriceFilter,
} from '../services/filters.service';
import { skip } from 'rxjs/operators';
import { FieldsDataService } from '../services/fields-data.service';
import { AnalyticsService, TRACK_ACTION } from '../services/analytics.service';
import { SeoService } from '../services/seo.service';
import { Observable, Observer } from 'rxjs';

export interface FieldInfo {
  title: string;
  price: string;
  priceFrom: number;
  priceTo: number;
  phone: string[];
  address: string;
  images: string[];
  link: string;
  lat: number;
  lng: number;
  features: {
    size: string;
    cover: string;
    roof: string;
    playersCapacity: string;
    workingSchedule: string;
    inventory: boolean;
    shower: boolean;
    wardrobe: boolean;
    lighting: boolean;
    parking: boolean;
    tribunes: boolean;
    toilet: boolean;
  };
}
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit {
  @ViewChild(IonContent, { static: true }) content: IonContent;
  clientWidth: number;
  scrollTop = 0;

  get football_fields_json() {
    return football_fields;
  }

  footballFields: FieldInfo[] = [];

  center: Coordinates = { lat: 50.45175712216151, lng: 30.53849732645677 }; // sort of Kiev center
  zoom = 11;
  geocoder: google.maps.Geocoder = new google.maps.Geocoder();

  listSize = '12';
  mapSize = '0';

  markers: any[] = [];

  constructor(
    public popoverController: PopoverController,
    private dimensionsService: DimensionsService,
    private router: Router,
    private mapService: MapService,
    private modalController: ModalController,
    private filtersService: FiltersService,
    private fieldsDataService: FieldsDataService,
    private analyticsService: AnalyticsService,
    private seoService: SeoService
  ) {}

  ngOnInit() {
    this.footballFields = this.football_fields_json;
    this.clientWidth = this.dimensionsService.getClientWidth();
    this.setMarkers();

    this.mapService.getMapView().subscribe((mapView: MapView) => {
      this.listSize = mapView.listSize;
      this.mapSize = mapView.mapSize;
    });

    this.mapService.getCoordinates().subscribe((center: Coordinates) => {
      this.center = center;
    });

    this.mapService.getZoom().subscribe((zoom: number) => {
      this.zoom = zoom;
    });

    this.filtersService
      .getFilter()
      .pipe(skip(1))
      .subscribe((filters) => {
        const filtersToApply = Object.entries(filters).filter(
          (entry) => entry[1].value
        ); // filter is set to true

        this.footballFields = this.football_fields_json.filter((field) => {
          let doesFieldMatch = true;

          filtersToApply.map((filterToApply: [string, FilterItem]) => {
            if (filterToApply[0] !== 'price') {
              // features filter
              if (field.features[filterToApply[0]] !== filterToApply[1].value) {
                doesFieldMatch = false;
              }
            } else {
              //price filter
              const priceFilter = filterToApply as unknown as [
                string,
                PriceFilter
              ];
              if (
                field.priceFrom < priceFilter[1].value.lower ||
                field.priceTo > priceFilter[1].value.upper
              ) {
                doesFieldMatch = false;
              }
            }
          });
          return doesFieldMatch;
        });
        this.setMarkers();
      });
  }

  ionViewWillEnter() {
    this.seoService.setSeoData(
      'Rentland | Аренда футбольных полей',
      'Выбирай поля на карте, применяй фильтры, бронируй прямо с сайта!',
      'https://rentland.com.ua/assets/icon/og-logo-square.png'
    );
    // this.generateSitemap();
  }

  setMarkers() {
    this.markers = [];
    for (let index = 0; index < this.footballFields.length; index++) {
      const element = this.footballFields[index];
      const lat = element.lat;
      const lng = element.lng;
      this.addMarker({ lat, lng }, element);
    }
    this.fieldsDataService.setVisibleFieldsCount(this.footballFields.length);
  }

  addMarker(position: { lat: number; lng: number }, element) {
    this.markers.push({
      position,
      label: {
        color: 'red',
      },
      ...element,
    });
  }

  toggleView() {
    if (this.listSize === '12') {
      this.mapService.showMap();
    } else {
      this.mapService.showList();
    }
  }

  async openFilters() {
    this.trackAction(TRACK_ACTION.OPEN_FILTERS);

    const modal = await this.modalController.create({
      component: FiltersComponent,
    });
    return await modal.present();
  }

  openOnMap(event: Event, fieldInfo: FieldInfo) {
    event.stopPropagation();

    this.trackAction(TRACK_ACTION.SHOW_ON_MAP, fieldInfo);

    if (this.clientWidth < 768) {
      this.toggleView();
    }

    const { lat, lng } = fieldInfo;
    this.mapService.setCoordinates({ lat, lng });
    this.mapService.setZoom(16);
  }

  async openInfo(fieldInfo: FieldInfo, trackAction?: TRACK_ACTION) {
    this.trackAction(trackAction, fieldInfo);

    this.router.navigate(['field-info'], {
      queryParams: { title: fieldInfo.title.trim().replace(/\ /g, '-') },
    });
  }

  trackAction(trackAction: TRACK_ACTION, fieldInfo?: FieldInfo) {
    this.analyticsService
      .trackAction(trackAction, fieldInfo)
      .subscribe((res) => console.log(res));
  }

  setSctoll(event: any) {
    this.scrollTop = event.detail.scrollTop;
  }

  get TRACK_ACTION() {
    return TRACK_ACTION;
  }

  // private generateFieldsIds() {
  //   const finalJson = [];

  //   this.football_fields_json.map((newField, index) => {
  //     const updatedField = this.football_fields_json.find(
  //       (field) => field.title === newField.title
  //     );

  //     updatedField.id = index;
  //     finalJson.push(updatedField);

  //     if (index === this.football_fields_json.length - 1) {
  //       console.warn(finalJson);
  //     }
  //   });
  // }

  private generateSitemap() {
    let sitemap = '';
    for (let index = 0; index < this.footballFields.length; index++) {
      sitemap =
        sitemap +
        `<url>
            <loc>https://rentland.com.ua/field-info?title=${this.footballFields[
              index
            ].title
              .trim()
              .replace(/\ /g, '-')}</loc>
            <changefreq>daily</changefreq>
            <priority>1.0</priority>
        </url>`;
    }
    console.warn('sitemap: ', sitemap);
  }

  // do not use without urgent need
  // private codeAddress(
  //   address: string
  // ): Observable<google.maps.GeocoderResult[]> {
  //   return new Observable(
  //     (observer: Observer<google.maps.GeocoderResult[]>) => {
  //       // Invokes geocode method of Google Maps API geocoding.
  //       this.geocoder.geocode(
  //         { address },
  //         (
  //           results: google.maps.GeocoderResult[],
  //           status: google.maps.GeocoderStatus
  //         ) => {
  //           if (status === google.maps.GeocoderStatus.OK) {
  //             observer.next(results);
  //             observer.complete();
  //           } else {
  //             console.log(
  //               'Geocoding service: geocode was not successful for the following reason: ' +
  //                 status
  //             );
  //             observer.error(status);
  //           }
  //         }
  //       );
  //     }
  //   );
  // }

  // do not use without urgent need
  // private parseAddressesToCoordinates() {
  //   const newListWithCoordinated = [];
  //   for (let index = 0; index < this.football_fields_json.length; index++) {
  //     setTimeout(() => {
  //       const element = this.football_fields_json[index];
  //       this.codeAddress(element.address).subscribe((res) => {
  //         const lat = res[0].geometry.location.lat();
  //         const lng = res[0].geometry.location.lng();
  //         console.log(
  //           res[0].geometry.location.lat(),
  //           res[0].geometry.location.lng()
  //         );
  //         newListWithCoordinated.push({ ...element, lat, lng });
  //         if (index === this.football_fields_json.length - 1) {
  //           console.log(newListWithCoordinated);
  //         }
  //       });
  //     }, 1000 * index);
  //   }
  // }

  // newFields.map((newField, index) => {
  //   let updatedField = football_fields_json.find(field => field.title === newField.title);

  //   if (updatedField && newField.image) {
  //     updatedField.image = newField.image;
  //     finalJson.push(updatedField)
  //   }

  //   if (index === newFields.length - 1) {
  //     console.warn(finalJson);

  //   }
  // })
}
